module.exports = __webpack_public_path__ + "static/media/NotFound.6695af99.svg";